import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export async function receiptPdf(name) {
  const el = document.getElementById("print-area");
  const fit = el.closest("[data-fit]");
  const prev = fit && fit.style.cssText;
  if (fit) { fit.style.transform = "none"; fit.style.width = "640px"; }
  let canvas;
  try {
    canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", useCORS: true });
  } finally {
    if (fit) fit.style.cssText = prev;
  }
  const pdf = new jsPDF({ unit: "mm", format: "a4" });
  const m = 6, pw = 210 - m * 2, ph = 297 - m * 2;
  let w = pw, h = (canvas.height * pw) / canvas.width;
  if (h > ph) { w = (w * ph) / h; h = ph; }
  pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", (210 - w) / 2, m, w, h);
  const blob = pdf.output("blob");
  return { blob, file: new File([blob], name, { type: "application/pdf" }) };
}

export const download = (blob, name) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
};

export const waNumber = (contact = "") => {
  const d = contact.replace(/\D/g, "");
  return d.length === 10 ? `91${d}` : d;
};
